import gql from 'graphql-tag';

export const updateApplicationMutation = gql`
  mutation ($input: ApplicationUpdateInput) {
    updateApplication(input: $input) {
      applicationId
      name
      remark
      date
      apiKey
      sdkKey
      configuration
      checkInInterval
      checkOutInterval
      inversedAttendance
      minisitePushLimit
      allowSMS
      allowEmail
    }
  }
`
